import { render, staticRenderFns } from "./Android.vue?vue&type=template&id=3d805450&scoped=true&"
import script from "./Android.vue?vue&type=script&lang=js&"
export * from "./Android.vue?vue&type=script&lang=js&"
import style0 from "./Android.vue?vue&type=style&index=0&id=3d805450&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d805450",
  null
  
)

export default component.exports